import { createSlice } from "@reduxjs/toolkit";


export interface deviceConfigStateType {
    loading: boolean;
    clientType: string;
    code: string;
    error: Error | null;
};
const initialState: deviceConfigStateType = {
    loading: false,
    clientType:'',
    code:'',
    error: null,
};


export const deviceConfigStateSlice = createSlice({
    name: "deviceConfigStateSlice",
    initialState,
    reducers:{
        setDeviceCode:(state,action)=>{
            state.code=action.payload
        },
        setClientType:(state,action)=>{
            state.clientType = action.payload
        }
    }
});

export const{
    setDeviceCode, setClientType
}=deviceConfigStateSlice.actions;

export default deviceConfigStateSlice.reducer;